import { Transforms } from 'slate';

import AddAnnotationTransform from '../ot-slate-v2/transforms/add_annotation';
import RemoveAnnotationTransform from '../ot-slate-v2/transforms/remove_annotation';
import SetAnnotationTransform from '../ot-slate-v2/transforms/set_annotation';
import AddMetadataTransform from '../ot-slate-v2/transforms/add_metadata';
import RemoveMetadataTransform from '../ot-slate-v2/transforms/remove_metadata';
import SetMetadataTransform from '../ot-slate-v2/transforms/set_metadata';

const __transform = Transforms.transform;
Transforms.transform = (editor, op) => {
  switch (op.type) {
    case 'add_annotation':
      return AddAnnotationTransform(editor, op);
    case 'remove_annotation':
      return RemoveAnnotationTransform(editor, op);
    case 'set_annotation':
      return SetAnnotationTransform(editor, op);
    case 'add_metadata':
      return AddMetadataTransform(editor, op);
    case 'remove_metadata':
      return RemoveMetadataTransform(editor, op);
    case 'set_metadata':
      return SetMetadataTransform(editor, op);
    default:
      return __transform(editor, op);
  }
};
